import { blogImgOne, blogImgTwo } from "../assets";

export const publications = [
  {
    href: "https://link.springer.com/chapter/10.1007/978-3-031-61060-8_24",
    image: blogImgOne,
    title: "June 2024",
    subTitle:
      "Autonomous Video Transmission and Air-to-Ground Coordination in UAV-Swarm-Aided Disaster Response Platform",
    shortTitle: "Autonomous Video Transmission in UAV-Swarm Platforms",
    category: "25th HCI International Conference",
    description:
      "This publication focuses on the use of UAV swarms for disaster response, presenting strategies for autonomous video transmission and coordination between drones and ground stations. The study demonstrates an improvement in mission planning and energy efficiency, making it a valuable resource for optimizing real-time disaster management systems.",
    authors: "Chaise Ballotti, Chengyi Qu, Wenbin Guo, Hong Wang",
    university:
      "Florida Gulf Coast University; University of Florida; Chang'an University",
  },
  {
    href: "https://drive.google.com/file/d/1GHUjOR-2IuOIRi1LyyT7UqIfOAUrB7_r/view?usp=sharing",
    image: blogImgTwo,
    title: "August 2025",
    subTitle:
      "HiFINS: A Hierarchical Federated Learning Based Interactive System for Smart Home Security",
    shortTitle: "HiFINS: Federated Learning Smart Home Security",
    category: "IEEE 2025",
    description:
      "This research applies artificial intelligence and federated learning to computer networks, developing a privacy-preserving intrusion detection system for smart homes. The framework uses generative models to detect network threats while maintaining decentralized learning, ensuring privacy and enhancing user autonomy.",
    authors:
      "Kevin Kostage, Sean Pepper, Paulo Drefahl, Wenbin Guo, Luca Mazzola, Chengyi Qu",
    university:
      "Florida Gulf Coast University; University of Florida; Lucerne University of Applied Sciences and Arts",
  },
];
